module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/validacao/validacao.component.css
// module id = ./src/app/validacao/validacao.component.css
// module chunks = main